<template>
  <div v-html="html">
    
  </div>
</template>
<script>
export default {
  data(){
    return{
      html:'',
    }
  },
  created(){
    this.html=this.$route.params.html;
    console.log(this.$route.params)
  }
}
</script>